import ResponsiveSidebar from "../../General/ResponsiveSidebar/ResponsiveSidebar";
import {
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Tooltip,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  Dashboard as DashboardIcon,
  EventAvailable as EventAvailableIcon,
  ReceiptLong as ReceiptLongIcon,
  ReportProblem as ReportProblemIcon,
  AssignmentInd as AssignmentIndIcon,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const drawerWidth = 240;
const collapsedWidth = 60;

interface SidebarProps {
  open?: boolean;
  toggle?: () => void;
}

const RecruitingSidebar = ({
  open = false,
  toggle = () => {},
}: SidebarProps) => {
  const location = useLocation();
  const { role } = useAuth();
  const hasRecruitingRole = role?.includes("Recruiting");

  const recruitingMenuItems = hasRecruitingRole
    ? [
        {
          text: "Dashboard",
          icon: <DashboardIcon />,
          path: "/recruiting",
        },
        {
          text: "Orientation Schedule",
          icon: <EventAvailableIcon />,
          path: "/recruiting/orientations",
        },
        {
          text: "Expenses",
          icon: <ReceiptLongIcon />,
          path: "/recruiting/orientation-expenses",
        },
        {
          text: "Orientation Calendar",
          icon: <EventAvailableIcon />,
          path: "/recruiting/orientation-calendar",
        },
        {
          text: "Driver Issues",
          icon: <ReportProblemIcon />,
          path: "/recruiting/driver-issues",
        },
        {
          text: "Applicants",
          icon: <AssignmentIndIcon />,
          path: "/recruiting/applicants",
        },
      ]
    : [
        {
          text: "Dashboard",
          icon: <DashboardIcon />,
          path: "/recruiting",
        },
        {
          text: "Orientation Calendar",
          icon: <EventAvailableIcon />,
          path: "/recruiting/orientation-calendar",
        },
      ];

  const isSelected = (path: string) => location.pathname.startsWith(path);

  return (
    <ResponsiveSidebar
      open={open}
      onClose={toggle}
      sx={(theme) => ({
        width: open ? drawerWidth : collapsedWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : collapsedWidth,
          boxSizing: "border-box",
          top: 64,
          height: "calc(100% - 64px)",
          overflowX: "hidden",
          position: "fixed",
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.standard,
          }),
        },
      })}
    >
      <Toolbar sx={{ justifyContent: open ? "flex-end" : "center" }}>
        <IconButton
          onClick={toggle}
          aria-label={
            open ? "Close section navigation" : "Open section navigation"
          }
        >
          {open ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Toolbar>
      <List>
        {recruitingMenuItems.map((item) => {
          const button = (
            <ListItemButton
              key={item.text}
              selected={isSelected(item.path)}
              component={RouterLink}
              to={item.path}
              sx={{ justifyContent: open ? "initial" : "center" }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 0,
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          );

          return open ? (
            button
          ) : (
            <Tooltip key={item.text} title={item.text} placement="right">
              {button}
            </Tooltip>
          );
        })}
      </List>
    </ResponsiveSidebar>
  );
};

export default RecruitingSidebar;
